import { ProductSummary } from '../../../features/package/packageInterface';
import { clientPackageDetailsTheadData } from '../../../data/admin-data';
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';

interface ClientPackageDetailsTBodyProps {
    prod: ProductSummary[] | null
    isLoading: boolean
    isError: boolean
    errorMessage: string;
    isEmpty: boolean
}

export default function ClientPackageDetailsTBody({ prod, isLoading, isEmpty, errorMessage, isError }: ClientPackageDetailsTBodyProps) {
    return (
        <tbody className='w-full'>
            {isLoading ? (
                <tr>
                    <td colSpan={clientPackageDetailsTheadData.length}  className='h-auto text-center'> 
                        <div className="flex space-x-1 justify-center items-center w-full h-full">
                            <Loading message="Loading product..." />
                        </div>
                    </td>
                </tr>
            ) : isError ? (
                <tr>
                    <td colSpan={clientPackageDetailsTheadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <ErrorMessage message={errorMessage} textStyle={``}/>
                        </div>
                    </td>
                </tr>
            ) : isEmpty ? (
                <tr>
                    <td colSpan={clientPackageDetailsTheadData.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <p className='text-gray-500 text-xs'>No result found.</p>
                        </div>
                    </td>
                </tr>
            ) : (
                prod?.map((prod, index) => {
                    const addons = prod.addons ?? []
                    const isActive = prod?.isActive ? 'Yes' : 'No'
                    const isAvailable = prod?.isAvailable ? 'Yes' : 'No'
                    const type = prod?.typeName === 'NONE' ? '' : prod?.typeName
                    return (
                        <tr 
                            key={prod.productID} 
                            className={`hover:bg-gray-100 text-xs cursor-pointer ${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}
                        >
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {prod.productName}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {type}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {prod.categoryName}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {isActive}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {isAvailable}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {prod?.size}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {prod?.price}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    {addons.map((add) => (
                                        <div key={add.addonID}>{add.addonName}</div>
                                    ))}
                                </div>
                            </th>
                        </tr>
                    )
                })
            )}
        </tbody>
    )
}
